import React from 'react';
import { Row, Col, FormGroup, Button } from 'react-bootstrap';
import { RichTextEditor, TextBox, CheckBox } from 'fw/forms';
import { SetupTab } from 'areas/shared/pages/setup';
import { Label } from 'fw/components';
import * as Notifications from 'fw/globals/Notifications';
import * as App from 'modules/app/App';
import * as API from 'modules/app/API';
import * as Modals from 'fw/globals/Modals';

class TermsAndConditionsInfoTab extends SetupTab {
    initialForm() {
        return { 
            content: "",
            description: "",
            active: true,
            rowVersion: null
        }
    }

    privileges() {
        return {
            add: App.hasPrivilege("AdminTermsAndConditionsSetupAdd"),
            edit: App.hasPrivilege("AdminTermsAndConditionsSetupEdit")
        }
    }

    urls() {
        return {
            get: API.App.url('/termsAndConditionsSetup/getTermsAndConditionsInfo'),
            save: API.App.url('/termsAndConditionsSetup/saveTermsAndConditionsInfo'),
            create: API.App.url('/termsAndConditionsSetup/createTermsAndConditions')
        }
    }

    getRequest(selectedId) {
        return {
            termsAndConditionsId: selectedId
        }
    }

    saveRequest() {
        return {
            termsAndConditionsId: this.props.selectedId,
            content: this.state.form.content,
            description: this.state.form.description,
            active: this.state.form.active,
            rowVersion: this.state.form.rowVersion
        }
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    confirmActiveNewTAC = () => {
        var rq = {
            termsAndConditionsId: this.props.selectedId
        };

        if (this.state.form.active)
        {
            API.App.post('/termsAndConditionsSetup/checkExistingTAC', rq, {
                success: (r) => {
                    if (r.data.existsAnotherActiveTAC)
                    {
                        Modals.confirm(
                            "Only one 'Terms & Conditions' statement can be selected; setting current one as Active will replace the previous one. <br /><br />" +
                            "If you wish to continue, please select 'Yes'. <br /><br />" +
                            "If you wish to Discard this change, please select 'No', and you will be returned to the previous screen.",
                            this.save
                        );
                    }
                    else
                    {
                        this.save();
                    }
                },
                error: r => {
                    Notifications.error(r.error.errorMessage);
                }
            });
        }
        else
        {
            this.save();
        }
    }

    renderButtons = () => {
		// Enable cancel if present
		const disableCancel = !this.state.buttons.cancel;

		//Show cancel
		const showCancel = this.state.showButtons.cancel;

		//Show save 
		const showSave = this.state.showButtons.save;

		return (
			<React.Fragment>
				<hr />
				<div className="pull-right">
					{((showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)) && <Button id="btnCancel" bsStyle="link" onClick={this.handleCancel} disabled={disableCancel}>Cancel</Button>}
					{((showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)) && 
                        <Button id="btnValidateSave"
                            bsStyle="primary"
                            onClick={this.confirmActiveNewTAC}>
                            Save Changes
                        </Button>
                    }
				</div>
			</React.Fragment>
		);
	}

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Label htmlFor="description" required>Terms & Conditions Title</Label>
                            <TextBox 
                                name="description" 
                                placeholder="Terms & Conditions Title"
                                maxLength={128} 
                                required 
                                ref={(c) => { this.focusControl = c; }} />                                    
                            <CheckBox name="active" label="Active" />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <FormGroup>
                            <RichTextEditor enabled={this.state.enabled} name="content" />
                        </FormGroup>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default TermsAndConditionsInfoTab; 



// WEBPACK FOOTER //
// ./src/areas/admin/termsAndConditionsSetup/termsAndConditionsInfo/TermsAndConditionsInfoTab.js